import validate from "/usr/src/nuxt-app/node_modules/nuxt/dist/pages/runtime/validate.mjs";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}